var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.916 32A6.458 6.458 0 1 1 1 32a6.458 6.458 0 1 1 12.916 0M63 32a6.458 6.458 0 1 1-12.916 0A6.458 6.458 0 1 1 63 32m-24.542 0a6.458 6.458 0 1 1-12.916 0 6.458 6.458 0 1 1 12.916 0"
})));
export default SvgMoreBold;